import { options } from "@/store/options";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  state: {
    isMobile: options.isMobile(),
    models: [311077, 313587],
    paymentType: options.paymentType,
    prices: {
      lowest: 0,
      highest: 0
    },
    priceRange: {
      monthly: {
        min: options.initialPrices.monthly.min,
        max: options.initialPrices.monthly.max
      },
      carPrice: {
        min: 0,
        max: 0
      }
    },
    year: {
      from: "",
      to: ""
    },
    transmission: [],
    fuelType: [],
    dealerLocations: [],
    regionsList: [],
    ordering: "price"
  },
  mutations,
  actions,
  getters
};
